import http from './index'

export const getLoginphone = function (data) {
    return http('/WebProgram/User/getCheckCode', data, 'POST')
}

export const getLogin = function (data) {
    return http('/WebProgram/User/login', data, 'POST')
}

export const getToken = function (data) {
    return http('/WebProgram/My/card', data, 'POST')
}
//login登录 MiniProgram/User/getCheckCode

export const getLogon = function (data) {
    return http('/WebProgram/User/register', data, 'POST')
}

//city
export const getRegionList = function (data) {
    return http('/WebProgram/WebApi/getRegionList', data, 'post')
}

//退出登录
export const getLogout = function (data) {
    return http('/WebProgram/User/logout', data, 'post')
}

//获取首页类目
export const getHome = function (data) {
    return http('https://city.newcoc.cn/api/v1/getCategoryList', data, 'POST')
}

//个人中心
export const orderList = function (data) {
    return http('/WebProgram/Order/orderList', data, 'post')
}

//智囊团
export const joinProviderList = function (data) {
    return http('/WebProgram/Order/joinProviderList', data, 'post')
}

//订单详情
export const getOrderInfo = function (data) {
    return http('/WebProgram/Order/getOrderInfo', data, 'post')
}

//商业资讯
export const getArticleList = function (data) {
    return http('/WebProgram/WebApi/getArticleList', data, 'post')
}

//资讯详情
export const getArticleById = function (data) {
    return http('/WebProgram/WebApi/getArticleById', data, 'post')
}

//购买服务
export const createOrder = function (data) {
    return http('/WebProgram/Order/createOrder', data, 'post')
}

//支付订单
export const payOrder = function (data) {
    return http('/WebProgram/Order/payOrder', data, 'post')
}

//确定订单
export const finishOrder = function (data) {
    return http('/WebProgram/Order/finishOrder', data, 'post')
}

export const orderDetails = function (data) {
    return http('/WebProgram/Order/orderDetails', data, 'post')
}

//发起合同
export const createContract = function (data) {
    return http('/WebProgram/Contract/createContract', data, 'post')
}

//下载合同
export const createPdf = function (data) {
    return http('/WebProgram/Contract/createPdf', data, 'post')
}

//查看合同
export const contractList = function (data) {
    return http('/WebProgram/Contract/contractList', data, 'post')
}

//微信支付
export const Index = function (data) {
    return http('/WebProgram/Wxpay/index', data, 'post')
}

//合同
export const OrderInfo = function (data) {
    return http('/WebProgram/Order/getOrderInfo', data, 'post')
}

//追加服务费
export const providerApp = function (data) {
    return http('/WebProgram/Order/providerApplyAdditional', data, 'post')
}

//查看合同
export const getcontractById = function (data) {
    return http('/WebProgram/Contract/getContractById', data, 'post')
}

//拒接验收

export const refused = function (data) {
    return http('/WebProgram/Order/memberRefusedAcceptance', data, 'post')
}

//同意验收
export const Acceptance = function (data) {
    return http('/WebProgram/Order/memberAcceptance', data, 'post')
}

//上传图片
export const uploadContractImg = function (data) {
    return http('/WebProgram/UpFile/uploadContractImg', data, 'post')
}

//获取商会列表
export const getBusinessList = function (data) {
    return http('/WebProgram/Home/getBusinessList', data, 'post')
}

//加入智囊团
export const joinProvider = function (data) {
    return http('/WebProgram/Order/joinProvider', data, 'post')
}

//加入智囊团列表
export const orderListByProviderId = function (data) {
    return http('/WebProgram/Order/orderListByProviderId', data, 'post')
}

//商会详情
export const getBusinessById = function (data) {
    return http('/WebProgram/Home/getBusinessById', data, 'post')
}

export const getBusinessArticle = function (data) {
    return http('/WebProgram/Home/getBusinessArticle', data, 'post')
}

//补充需求
export const createOrderReply = function (data) {
    return http('/WebProgram/Order/orderRemarkAdd', data, 'post')
}

//关闭需求
export const delOrder = function (data) {
    return http('/WebProgram/Order/delOrder', data, 'post')
}

//评价
export const createorderReply = function (data) {
    return http('/WebProgram/Order/createOrderReply', data, 'post')
}

//申请加入商会API
export const applyBusiness = function (data) {
    return http('/WebProgram/User/applyBusiness', data, 'post')
}

//追加服务费
export const Additional = function (data) {
    return http('/WebProgram/Order/providerApplyAdditional', data, 'post')
}

//需求记录
export const orderRemarkAdd = function (data) {
    return http('/WebProgram/Order/orderRemarkList', data, 'post')
}

//服务费记录
export const getServiceLogList = function (data) {
    return http('/WebProgram/Service/getServiceLogList', data, 'post')
}

//合作订单
export const getListByProviderId = function (data) {
    return http('/WebProgram/Order/orderListByProviderId', data, 'post')
}

//支付
export const add_price = function(data){
    return http('/WebProgram/Wxpay/add_price' ,data,'post')
}

//追加服务费详情
export const getOrderServiceLog = function(data){
    return http('/WebProgram/Order/getOrderServiceLog',data,'post')
}

//商会动态详情
export const articleInfo = function(data){
    return http('/WebProgram/Home/articleInfo',data,'post')
}

//评价
export const createQuestionReplay = function(data){
    return http('/api/v1/createQuestionReplay',data,'post')
}


const dealArr = (val) => {
    return dealArr.splice(',')
}


// WEBPACK FOOTER //
// ./src/http/api.js